/**
 * Copyright (c) 2015-present, Axsy Software Ltd
 *
 * @providesModule ReactListView
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ReactListViewDataSource = require('ReactListViewDataSource');

var _ReactListViewDataSource2 = _interopRequireDefault(_ReactListViewDataSource);

var _WinJSDataSourceAdapter = require('WinJSDataSourceAdapter');

var _WinJSDataSourceAdapter2 = _interopRequireDefault(_WinJSDataSourceAdapter);

var _reactWinjs = require('react-winjs');

var _reactWinjs2 = _interopRequireDefault(_reactWinjs);

var ListView = (function (_React$Component) {
  _inherits(ListView, _React$Component);

  _createClass(ListView, [{
    key: 'itemRenderer',

    // winJS mappings
    value: function itemRenderer(renderRow) {
      return _reactWinjs2['default'].reactRenderer(function (item) {
        return renderRow(item.data);
      });
      //
    }

    // Constructor
  }], [{
    key: 'DataSource',

    // pass down the ability to instantiate new listView.DataSource(...)
    value: function DataSource(params) {
      return new _ReactListViewDataSource2['default'](params);
    }
  }]);

  function ListView(props, context) {
    _classCallCheck(this, ListView);

    _get(Object.getPrototypeOf(ListView.prototype), 'constructor', this).call(this, props, context);
    this.winjsbinding = new _WinJSDataSourceAdapter2['default'].datasource(this);
  }

  _createClass(ListView, [{
    key: 'updateDataSource',
    value: function updateDataSource(normalReactDataSource) {
      if (this.dataSource != normalReactDataSource) {
        this.dataSource = normalReactDataSource;
        this.state = {
          update: 1
        };
        this.winjsbinding.invalidateAll();
        console.log("set for update");
      }
    }

    // callbacks

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      console.log("componentDidMount");
      var normalReactDataSource = this.props.dataSource;
      this.updateDataSource(normalReactDataSource);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      console.log("componentWillReceiveProps");
      this.updateDataSource(nextProps.dataSource);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.refs.listView && this.refs.listView.winControl && this.refs.listView.winControl.selection.clear();
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var update = false;
      if (this.state.update) {
        update = true;
        this.state = {
          update: 0
        };
      }
      console.log("shouldComponentUpdate " + update);
      return update;
    }
  }, {
    key: 'onItemInvoked',
    value: function onItemInvoked(event) {
      var _this = this;

      var id = event.detail.itemIndex;

      setImmediate(function () {
        _this.props.onItemSelect && _this.props.onItemSelect(id);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2['default'].createElement(_reactWinjs2['default'].ListView, _extends({
        ref: 'listView',
        itemDataSource: this.winjsbinding,
        itemTemplate: this.itemRenderer(this.props.renderRow),
        onItemInvoked: this.onItemInvoked.bind(this)
      }, this.props));
    }
  }]);

  return ListView;
})(_react2['default'].Component);

exports['default'] = ListView;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/lib/ListView/ListView.winjs.js
 **/